// Display helpers shared by the dashboard pages (auto-imported).

type Named = { first_name?: string | null; last_name?: string | null; email?: string | null }

/** "Vezetéknév Keresztnév", falling back to the e-mail, then a dash. */
export function personName(u: Named | null | undefined, fallback = '—'): string {
  if (!u) return fallback
  return [u.last_name, u.first_name].filter(Boolean).join(' ') || u.email || fallback
}

/** Up to two initials from the letters of a name ("[demo] Csapat 1" → "DC"). */
export function initialsOf(name: string | null | undefined): string {
  const words = (name ?? '').replace(/[^\p{L}\p{N}\s]/gu, ' ').split(/\s+/).filter(Boolean)
  if (!words.length) return '?'
  return words.slice(0, 2).map((w) => w.charAt(0).toUpperCase()).join('')
}

/** 2026. 09. 25. — or a dash for no date. */
export function fmtDate(d: string | Date | null | undefined, fallback = '—'): string {
  if (!d) return fallback
  const date = new Date(d)
  return Number.isNaN(date.getTime()) ? fallback : date.toLocaleDateString('hu-HU')
}

/** 2026. 09. 25. 14:05 — or a dash for no date. */
export function fmtDateTime(d: string | Date | null | undefined, fallback = '—'): string {
  if (!d) return fallback
  const date = new Date(d)
  return Number.isNaN(date.getTime())
    ? fallback
    : date.toLocaleString('hu-HU', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
}

/** "épp most", "3 perccel ezelőtt", "2 napja" — for recent timestamps; older ones get a date. */
export function fmtRelative(d: string | Date | null | undefined, fallback = '—'): string {
  if (!d) return fallback
  const t = new Date(d).getTime()
  if (Number.isNaN(t)) return fallback
  const diff = Math.round((t - Date.now()) / 1000)
  const abs = Math.abs(diff)
  const rtf = new Intl.RelativeTimeFormat('hu', { numeric: 'auto' })
  if (abs < 45) return 'épp most'
  if (abs < 90) return rtf.format(Math.sign(diff), 'minute')
  if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute')
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour')
  if (abs < 86400 * 30) return rtf.format(Math.round(diff / 86400), 'day')
  return fmtDate(d)
}
